import type { Struct } from 'superstruct';
import { coerce, string, trimmed } from 'superstruct';

import { withMessage } from './withMessage';

/**
 * Augment a struct to replace `''` values with `null`.
 *
 * Note: If also using `trimmed` and you want strings like `' '`
 *       to coerce to null, put `trimmed(emptyStringIsNull(string()))`.
 *       This will make `trimmed` run before `emptyStringIsNull`.
 *
 * Note: You must use `mask(value, Struct)` on the value to have the coercion
 *       take effect! Using simply `assert()` or `is()` will not use coercion.
 */
export function emptyStringIsNull<T, S>(struct: Struct<T, S>): Struct<T, S> {
	return coerce(struct, string(), (x) => (x.length > 0 ? x : null));
}

/**
 * For validating user strings. Trims ends and requires non-empty string.
 *
 * @param validationKey The translation key to use for the validation error
 * message.
 */
export const userString = (validationKey: string) =>
	withMessage(trimmed(emptyStringIsNull(string())), validationKey);
